import { createFileRoute } from '@tanstack/react-router';
import { IncomeTaxStatementProfileRegistryPage } from './-components/IncomeTaxStatementProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/income-tax-statements/')({
  component: IncomeTaxStatementProfileRegistryPage
});